<template>
  <div class="side-footer">
    <div class="back-to" :title="$t('homeTitle')" @click="backTo()">
      <svg-icon class-name="sidebar-icon" icon-class="home" />
    </div>
    <div
      v-show="
        sidebar.opened && !routePath.startsWith('/multidimensional-query') && !routePath.startsWith('/sq')
      "
      class="side-footer-right"
    >
      <div>
        <svg-icon
          class-name="sidebar-icon"
          :icon-class="`sidebar-language-${language}`"
          @click="switchLanguage"
        />
      </div>
      <div>
        <svg-icon
          class-name="sidebar-icon"
          icon-class="video"
          @click="handleShow"
        />
      </div>
      <a-popover
        trigger="click"
        placement="rightBottom"
        overlay-class-name="pop-up-box"
        :get-popup-container="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }
        "
        :overlay-style="{
          padding: 0
        }"
      >
        <ul slot="content">
          <li>
            <a @click="panelChange('UserCenter')">
              {{ $t("userCenter") }}
            </a>
          </li>
          <li>
            <a @click="panelChange('SwitchAccount')">
              {{ $t("switchAccount") }}
            </a>
          </li>
          <li>
            <a @click="logout()">{{ $t("logout") }}</a>
          </li>
        </ul>
        <div>
          <img
            v-if="userInfo.headPicPath"
            :src="userInfo.headPicPath"
            class="avatar"
          />
          <svg-icon v-else class-name="avatar" icon-class="avatar" />
        </div>
      </a-popover>
      <a-modal
        v-model="visible"
        :body-style="{ padding: 0 }"
        :closable="false"
        centered
        :width="1000"
        destroy-on-close
        :footer="null"
      >
        <video
          autoplay="autoplay"
          controls="controls"
          controlslist="nodownload"
          width="100%"
        >
          <source :src="videoAddress" type="video/mp4" />
          您的浏览器不支持 video 标签。
        </video>
      </a-modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import actions from "@/utils/actions";
import moment from "moment";
export default {
  data() {
    return {
      visible: false,
      popUpBl: false
    };
  },
  computed: {
    ...mapGetters(["microAppRoutes", "sidebar"]),
    ...mapState({
      userInfo: state => state.user.userInfo,
      language: state => state.app.language
    }),
    publicPath() {
      let { path, query } = this.$route;
      path = path
        .split("/")
        .slice(0, 2)
        .join("/");

      if (query && query.product) {
        return decodeURIComponent(query.product);
      }
      return path;
    },
    videoAddress() {
      const item = this.microAppRoutes?.find(
        item => item.path === this.publicPath
      );
      return item?.videoUrl || "";
    },
    routePath() {
      return this.$route.path;
    }
  },
  methods: {
    backTo() {
      this.$router.push("/dashboard");
    },
    panelChange(value) {
      this.$emit("panelChange", value);
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      this.$router.push(`/home?redirect=${this.$route.path}`);
    },
    switchLanguage: function() {
      const language = this.language === "zh_CN" ? "en" : "zh_CN";
      this.$i18n.locale = language;
      this.$store.dispatch("app/toggleLanguage", language);
      actions.setGlobalState({
        language,
        time: moment().format("yyyy.MM.DD HH:mm:ss")
      });
      this.$message({
        type: "success",
        message: this.$t("switchLanguage"),
        customClass: "message-success"
      });
    },
    handleShow() {
      !this.visible && (this.visible = true);
    }
  }
};
</script>

<style lang="scss" scoped>
.side-footer {
  color: #ffffff;
  font-size: 12px;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 2;
  &-right {
    display: flex;
    border-top: 1px solid #fff;
    > div {
      cursor: pointer;
      text-align: center;
      line-height: 40px;
      width: 58px;
      background: #f0f5ff;
    }
  }

  .avatar,
  .sidebar-icon {
    cursor: pointer;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    vertical-align: middle;
  }

  .back-to {
    display: flex;
    width: 56px;
    height: 40px;
    justify-content: center;
    align-items: center;
    border-top: 1px solid rgba(255, 255, 255, 0.4);
  }
}
</style>
<style lang="scss">
@import "~@/styles/variables";
.pop-up-box {
  .ways-popover-content {
    border-radius: 8px 8px 0px 0px;
    transform: translateY(-18px) translateX(-10px);
    box-shadow: 0px 20px 40px 0px rgba(47, 46, 65, 0.1);
  }
  .ways-popover-arrow {
    display: none;
  }
  .ways-popover-inner-content {
    color: #262626;
    font-size: 12px;
    font-weight: 400;
    line-height: 12px; /* 100% */
    padding: 0;
    background: #fff;
    border-radius: 4px;
    ul {
      li {
        display: flex;
        padding: 8px 16px;
        justify-content: center;
        cursor: pointer;
        transition: 0.3s all;
        a {
          color: $subMenuText;
          white-space: nowrap;
        }
        &:hover {
          background: #f0f5ff;
          color: $primary-color;
          a:hover {
            color: $primary-color;
          }
        }
      }
    }
  }
}
</style>
